module.exports = __webpack_public_path__ + "static/media/logo.b342e621.svg";